document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});
$(document).ready(function(){
    customProduct();
})

function customProduct() {
  var customerData = getShoptetDataLayer('customer') || {};
  var priceListId = customerData.priceListId;
  var activeCategory = $('.breadcrumbs #navigation-1 span[itemprop="name"]').text().trim();
  function applyRestrictions(textMessage) {
    if ($('.product').length) {
      $('.product').each(function () {
        //$(this).find('.prices .price').html('&nbsp;');
        $(this).find('.p-tools>form').replaceWith('<a href="' + $(this).find('.image').attr('href') + '" class="btn btn-primary">Detail</a>');
      });
    }
    if ($('.type-detail').length) {
      $('#product-detail-form .p-to-cart-block').find('.add-to-cart').remove();
      $('#product-detail-form .p-to-cart-block').append(textMessage);
    }
  }
  if (restrictedPriceListIds.includes(priceListId)) {
    if (visibleProductsCategories.includes(activeCategory)) {
      applyRestrictions(textForMO);
    }
  } else if (pricelistIds.includes(priceListId)) {
    if (!visibleProductsCategories.includes(activeCategory)) {
      applyRestrictions(textForVO);
    }
  }
}
